import React, { useCallback, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { useIsUserAnalysisEnabled } from 'apps/sigma2-ui/src/components/ui/useUserAnalysis';
import { useUserAnalysis } from 'apps/sigma2-ui/src/components/ui/useUserAnalysis';
import { UserAnalysisContext } from 'apps/sigma2-ui/src/state/user-analysis-context';

export const UserAnalysisSignaling = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isUserAnalysisEnabled = useIsUserAnalysisEnabled();

  const useUserAnalysisPayload = useUserAnalysis();

  const [currentSignalId, setCurrentSignalId] = useState<string | null>(null);

  const sendSignal = useCallback(
    (customVizDefinition: CustomVizDefinition) => {
      if (!isUserAnalysisEnabled) {
        return;
      }
      if (customVizDefinition.isDataQueuingAllowed) {
        const newSignalId = uuidv4();
        setCurrentSignalId(newSignalId);
        useUserAnalysisPayload.handleManualFetch();
      }
    },
    [isUserAnalysisEnabled, useUserAnalysisPayload],
  );

  const value = useMemo(() => {
    return {
      sendSignal,
      currentUserAnalyses: useUserAnalysisPayload.currentUserAnalyses,
      onDeleteUserAnalysis: useUserAnalysisPayload.onDeleteUserAnalysis,
      onRetryUserAnalysis: useUserAnalysisPayload.onRetryUserAnalysis,
    };
  }, [sendSignal, useUserAnalysisPayload]);

  return (
    <UserAnalysisContext.Provider value={value}>
      {children}
    </UserAnalysisContext.Provider>
  );
};
